import * as React from 'react';
import { Storage, AsyncStorage } from 'services';
import { useState, useEffect } from 'react';
import { BootScreen } from 'screens';

// Types
type Action = { type: 'COMPLETE'; payload: any };
type Dispatch = (action: Action) => void;
type State = {
  groupGetStartedCompleteList: Array<string>;
};

const GroupGetStartedStateContext = React.createContext<State | undefined>(undefined);

const GroupGetStartedDispatchContext = React.createContext<Dispatch | undefined>(undefined);

async function getInitialState() {
  try {
    let groupGetStartedCompleteList = await AsyncStorage.get('get-started-complete');

    if (!groupGetStartedCompleteList) groupGetStartedCompleteList = [];

    return {
      groupGetStartedCompleteList,
    } as State;
  } catch (error) {
    const defaultState = {
      groupGetStartedComplete: [],
    };
    return defaultState;
  }
}

export const groupGetStartedReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'COMPLETE':
      let groupGetStartedCompleteList: any = Storage.get('get-started-complete');

      if (!groupGetStartedCompleteList) {
        groupGetStartedCompleteList = new Array(action.payload);
      } else {
        groupGetStartedCompleteList = JSON.parse(groupGetStartedCompleteList);
        groupGetStartedCompleteList.push(action.payload);
      }

      Storage.set('get-started-complete', JSON.stringify(groupGetStartedCompleteList));

      return {
        ...state,
        groupGetStartedCompleteList,
      };
    default:
      return state;
  }
};

export const GroupGetStartedProvider: React.ComponentType<React.ReactNode> = ({
  children,
}: any) => {
  const [state, setState] = useState<any>(null);

  useEffect(() => {
    getInitialState().then((response) => {
      setState(response);
    });
  }, []);

  if (!state) return <BootScreen />;

  return <Provider initialState={state}>{children}</Provider>;
};

const Provider = ({ children, initialState }: any) => {
  const [state, dispatch] = React.useReducer(groupGetStartedReducer, initialState);
  return (
    <GroupGetStartedStateContext.Provider value={state}>
      <GroupGetStartedDispatchContext.Provider value={dispatch}>
        {children}
      </GroupGetStartedDispatchContext.Provider>
    </GroupGetStartedStateContext.Provider>
  );
};

export const useGroupGetStartedState = () => {
  const context = React.useContext(GroupGetStartedStateContext);
  if (context === undefined) {
    throw new Error('useGroupGetStartedState must be used within a GroupGetStartedProvider');
  }
  return context;
};

export const useGroupGetStartedDispatch = () => {
  const context = React.useContext(GroupGetStartedDispatchContext);
  if (context === undefined) {
    throw new Error('useGroupGetStartedDispatch must be used within a GroupGetStartedProvider');
  }
  return context;
};
